var _path, _path2, _g, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWrite = function SvgWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEBEC",
    fillRule: "evenodd",
    d: "m11.604 54.744 31.52.038.055-43.948-36.023-.043-.05 39.553c-.003 2.427 2.01 4.397 4.498 4.4",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "write_svg__a",
    width: 44,
    height: 52,
    x: 3,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.556 7.322h43.178v50.929H3.556z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#write_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    fillRule: "evenodd",
    d: "m46.734 7.374-3.55-.004L7.16 7.326l-3.55-.004-.005 3.465-.05 39.553c-.005 4.333 3.603 7.863 8.044 7.869l31.52.037 3.55.005.005-3.465.055-43.947zm-3.555 3.46-.055 43.948-31.52-.038c-2.488-.003-4.501-1.973-4.498-4.4l.05-39.553z",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "m14.65 18.367-.004 3.465 21.014.026.004-3.465zM14.636 30.621l12.008.015.004-3.465-12.008-.014z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D23",
    fillRule: "evenodd",
    d: "M58.863 26.916a5 5 0 0 0 .009-7.191c-2.032-1.988-5.33-1.992-7.368-.009L30.177 40.481l7.358 7.198z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4B4C",
    fillRule: "evenodd",
    d: "m30.166 40.48 7.358 7.2-8.942 1.524z",
    clipRule: "evenodd"
  })));
};
export default SvgWrite;